import { TFunction } from "react-i18next";
import { NUTRIENT_RECOMMENDATION_GRADIENT_COLORS } from "../theme/theme";

export const getNutrientIndicationDispositionStringForValue = (value: number, t: TFunction<string>) => {
  if (value < -80) {
    return t("nutrient.disposition.importance_level.essential");
  } else if (value < -60) {
    return t("nutrient.disposition.importance_level.very_important");
  } else if (value < -40) {
    return t("nutrient.disposition.importance_level.important");
  } else if (value < -20) {
    return t("nutrient.disposition.importance_level.moderately");
  } else if (value < 0) {
    return t("nutrient.disposition.importance_level.slightly");
  } else if (value === 0) {
    return t("nutrient.disposition.importance_level.neutral");
  } else if (value < 20) {
    return t("nutrient.disposition.importance_level.slightly");
  } else if (value < 40) {
    return t("nutrient.disposition.importance_level.moderately");
  } else if (value < 60) {
    return t("nutrient.disposition.importance_level.important");
  } else if (value < 80) {
    return t("nutrient.disposition.importance_level.very_important");
  } else {
    return t("nutrient.disposition.importance_level.essential");
  }
};

export const getNutrientIndicationColorForValue = (value: number) => {
  if (value < 0) {
    return NUTRIENT_RECOMMENDATION_GRADIENT_COLORS.BAD;
  } else if (value === 0) {
    return NUTRIENT_RECOMMENDATION_GRADIENT_COLORS.NEUTRAL;
  } else {
    return NUTRIENT_RECOMMENDATION_GRADIENT_COLORS.GOOD;
  }
};
